import { fetchWithAuth, getAccessToken } from '../../../auth'
import React, { useState, useEffect } from 'react'
import LoadingScreen from '../../../components/LoadingScreen'
import LoadingSpinner from '../../../components/LoadingSpinner'
import dayjs from '../../../utils/dayjsConfig'
import { Table } from 'react-bootstrap'

const ClientHistoryTab = () => {
  const [isFetching, setIsFetching] = useState(false)
  const [userRefundAuditData, setUserRefundAuditData] = useState([])

  useEffect(() => {
    const abortController = new AbortController()

    const handleBeforeUnload = () => abortController.abort('Fetch aborted by user')
    window.addEventListener('beforeunload', handleBeforeUnload)

    fetchUserRefundAuditsFromServer(abortController.signal)

    return () => {
      abortController.abort()
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return (
    <div className="show-area-tab">
      <div className="show-header show-routes-header">
        <h2 className="show-routes-subtitle">Historial del máximo de devoluciones:</h2>
      </div>
      <hr className="mt-50" />
      {!isFetching && (
        <>
          <div className="mt-25">
            <b>Ajustes registrados</b>
          </div>
          <div className="mt-20">
            <Table hover responsive>
              <thead className="table-header-gray">
                <tr>
                  <th className="vertical-align-middle" style={{ padding: '10px 25px' }}>
                    <span className="th-header-text">FECHA Y HORA</span>
                  </th>
                  <th
                    className="vertical-align-middle"
                    title="Es el nombre del usuario que realizó el ajuste del máximo de devoluciones."
                  >
                    <span className="th-header-text">NOMBRE DE USUARIO</span>
                    <FontAwesomeIcon icon={faQuestionCircle} className="ml-2" />
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">TIPO DE CAMBIO</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">REGISTRO ANTERIOR</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">REGISTRO NUEVO</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {userRefundAuditData?.map((month, indx) => (
                  <tr key={indx}>
                    <td className="td-text-limited td-text-limited-space">
                      {dayjs(month.created_at).local().format('DD/MM/YYYY, h:mm A')}
                    </td>
                    <td className="td-text-limited">{month.supervisor_name}</td>
                    <td className="td-text-limited">{`MÁXIMO DE DEVOLUCIONES`}</td>
                    <td className="td-text-limited">
                      {month.action == 'create'
                        ? '$0.00'
                        : `$${Number(month.audited_changes.current_amount[0]).toFixed(2)}`}
                    </td>
                    <td className="td-text-limited">
                      {month.action == 'create'
                        ? `$${Number(month.audited_changes.current_amount).toFixed(2)}`
                        : `$${Number(month.audited_changes.current_amount[1]).toFixed(2)}`}
                    </td>
                  </tr>
                ))}
                {userRefundAuditData?.length === 0 && (
                  <tr>
                    <td colSpan="5" className="td-text-no-border">
                      Aún no hay ajustes registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>{' '}
        </>
      )}
      {isFetching && (
        <div className="loading-fullscreen">
          <div className="loading-card">
            <LoadingSpinner text="Cargando..." />
          </div>
        </div>
      )}
    </div>
  )
}

export default ClientHistoryTab
